import posthog from 'posthog-js'

// Initialize PostHog only in production
const initPostHog = () => {
  if (import.meta.env.PROD) {
    posthog.init('phc_LSXY00fMLRgNF7foZt91Cg3boz09FYL888uUNCJJhUw', {
      api_host: 'https://us.i.posthog.com',
      defaults: '2025-05-24',
      person_profiles: 'identified_only',
      capture_pageview: false, // We'll capture manually
      capture_pageleave: true,
      enable_heatmaps: true,
      session_recording: {
        maskAllInputs: false,
        maskInputOptions: {
          password: true,
        }
      },
      autocapture: {
        capture_copied_text: true,
      },
      // Enable automatic error tracking
      capture_performance: true,
      disable_session_recording: false,
    })

    // Set up automatic error tracking
    window.addEventListener('error', (event) => {
      posthog.capture('$exception', {
        $exception_type: 'Error',
        $exception_message: event.error?.message || event.message,
        $exception_stack_trace_raw: event.error?.stack,
        $exception_source: event.filename,
        $exception_lineno: event.lineno,
        $exception_colno: event.colno,
      })
    })

    window.addEventListener('unhandledrejection', (event) => {
      posthog.capture('$exception', {
        $exception_type: 'Promise Rejection',
        $exception_message: event.reason?.message || String(event.reason),
        $exception_stack_trace_raw: event.reason?.stack,
      })
    })
  }
}

export { posthog, initPostHog }